// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.courses-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.training-container {
  display: flex;
}

.training-jumbotron {
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  width: 100%;
  position: relative;
  background-color: black;
}

.training-overlay {
  background-color: black;
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.6;
  z-index: 2;
}

video {
  overflow: hidden;
}

.training-cards-container {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 5;
}

.more-training {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.more-training-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  padding: 10em 5em;
}

.blog-info {
  font-size: 1.5em;
  line-height: 2.1em;
  display: flex;
  position: absolute;
  z-index: 5;
  left: 0;
  width: 50rem;
  padding: 1rem;
  bottom: 5%;
  color: white;
  font-family: "Spartan", sans-serif;
  animation: fadeIn 1s ease-in-out forwards;
}

.photo {
  background-image: url("https://ljc-site.s3.us-east-2.amazonaws.com/img/adaptability-Q.png");
  background-position: 80% 20%;
  background-repeat: no-repeat;
}

.photo-2 {
  background-image: url("https://ljc-site.s3.us-east-2.amazonaws.com/img/change-management.png");
  background-repeat: no-repeat;
}

.photo-3 {
  background-image: url("https://ljc-site.s3.us-east-2.amazonaws.com/img/dei.png");
  background-repeat: no-repeat;
}

.photo-4 {
  background-image: url("https://ljc-site.s3.us-east-2.amazonaws.com/img/hr.png");
  background-repeat: no-repeat;
}

.photo-5 {
  background-image: url("https://ljc-site.s3.us-east-2.amazonaws.com/img/adaptability.jpeg");
  background-repeat: no-repeat;
}

.photo-6 {
  background-image: url("https://ljc-site.s3.us-east-2.amazonaws.com/img/leadership-development.png");
  background-repeat: no-repeat;
}

.blog-card {
  display: flex;
  flex-direction: column;
  margin: 1rem;
  box-shadow: 0 3px 7px -1px rgba(0, 0, 0, 0.1);
  margin-bottom: 1.6%;
  background: #fff;
  line-height: 1.4;
  font-family: sans-serif;
  border-radius: 5px;
  overflow: hidden;
  z-index: 0;
}

.blog-card a {
  color: inherit;
}

.blog-card a:hover {
  color: #5ad67d;
}

.blog-card:hover .photo {
  transform: scale(1.3) rotate(3deg);
}

.blog-card:hover .photo-2 {
  transform: scale(1.3) rotate(3deg);
}

.blog-card:hover .photo-3 {
  transform: scale(1.3) rotate(3deg);
}

.blog-card:hover .photo-4 {
  transform: scale(1.3) rotate(3deg);
}

.blog-card:hover .photo-5 {
  transform: scale(1.3) rotate(3deg);
}

.blog-card:hover .photo-6 {
  transform: scale(1.3) rotate(3deg);
}

.blog-card .meta {
  position: relative;
  z-index: 0;
  height: 200px;
}

.blog-card .photo {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-size: cover;
  background-position: 10%;
  transition: transform 0.2s;
}

.blog-card .photo-2 {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-size: cover;
  background-position: center;
  transition: transform 0.2s;
}

.blog-card .photo-3 {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-size: cover;
  background-position: center;
  transition: transform 0.2s;
}

.blog-card .photo-4 {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-size: cover;
  background-position: 10%;
  transition: transform 0.2s;
}

.blog-card .photo-5 {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-size: cover;
  background-position: center;
  transition: transform 0.2s;
}

.blog-card .photo-6 {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-size: cover;
  background-position: center;
  transition: transform 0.2s;
}

.blog-card .details,
.blog-card .details ul {
  margin: auto;
  padding: 0;
  list-style: none;
}

.blog-card .details {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -100%;
  margin: auto;
  transition: left 0.2s;
  background: rgba(51, 125, 239, 0.6);
  color: #fff;
  padding: 10px;
  width: 100%;
  font-size: 0.9rem;
}

.blog-card .details-2,
.blog-card .details-2 ul {
  margin: auto;
  padding: 0;
  list-style: none;
}

.blog-card .details-2 {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -100%;
  margin: auto;
  transition: left 0.2s;
  background: rgba(57, 8, 121, 0.6);
  color: #fff;
  padding: 10px;
  width: 100%;
  font-size: 0.9rem;
}

.blog-card .details-3,
.blog-card .details-3 ul {
  margin: auto;
  padding: 0;
  list-style: none;
}

.blog-card .details-3 {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -100%;
  margin: auto;
  transition: left 0.2s;
  background: rgba(165, 227, 0, 0.6);
  color: #fff;
  padding: 10px;
  width: 100%;
  font-size: 0.9rem;
}

.blog-card .details-4,
.blog-card .details-4 ul {
  margin: auto;
  padding: 0;
  list-style: none;
}

.blog-card .details-4 {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -100%;
  margin: auto;
  transition: left 0.2s;
  background: rgba(165, 227, 0, 0.6);
  color: #fff;
  padding: 10px;
  width: 100%;
  font-size: 0.9rem;
}

.blog-card .details-5,
.blog-card .details-5 ul {
  margin: auto;
  padding: 0;
  list-style: none;
}

.blog-card .details-5 {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -100%;
  margin: auto;
  transition: left 0.2s;
  background: rgba(165, 227, 0, 0.6);
  color: #fff;
  padding: 10px;
  width: 100%;
  font-size: 0.9rem;
}

.blog-card .details-6,
.blog-card .details-6 ul {
  margin: auto;
  padding: 0;
  list-style: none;
}

.blog-card .details-6 {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -100%;
  margin: auto;
  transition: left 0.2s;
  background: rgba(165, 227, 0, 0.6);
  color: #fff;
  padding: 10px;
  width: 100%;
  font-size: 0.9rem;
}

.blog-card .description {
  padding: 1rem;
  background: #fff;
  position: relative;
  z-index: 1;
}

.blog-card .description h1,
.blog-card .description h2 {
  font-family: Poppins, sans-serif;
}

.blog-card .description h1 {
  line-height: 1;
  margin: 0;
  font-size: 1.7rem;
}

.blog-card .description h2 {
  font-size: 0.8rem;
  font-weight: 300;
  text-transform: uppercase;
  color: #a2a2a2;
  margin-top: 5px;
}

.blog-card .description .read-more {
  text-align: right;
}

.blog-card .description .read-more a {
  color: #5ad67d;
  display: inline-block;
  position: relative;
}

.blog-card .description .read-more a:after {
  content: "\\f061";
  font-family: FontAwesome;
  margin-left: -10px;
  opacity: 0;
  vertical-align: middle;
  transition: margin 0.3s, opacity 0.3s;
}

.blog-card .description .read-more a:hover:after {
  margin-left: 5px;
  opacity: 1;
}

.blog-card p {
  position: relative;
  margin: 1rem 0 0;
  font-size: 0.85em;
}

.blog-card p:first-of-type {
  margin-top: 1.25rem;
}

.blog-card p:first-of-type:before {
  content: "";
  position: absolute;
  height: 5px;
  background: #5ad67d;
  width: 35px;
  top: -0.75rem;
  border-radius: 3px;
}

.blog-card:hover .details {
  left: 0%;
}

.blog-card:hover .details-2 {
  left: 0%;
}

.blog-card:hover .details-3 {
  left: 0%;
}

.blog-card:hover .details-4 {
  left: 0%;
}

.blog-card:hover .details-5 {
  left: 0%;
}

.blog-card:hover .details-6 {
  left: 0%;
}

@media (min-width: 640px) {
  .blog-card {
    flex-direction: row;
    width: 40em;
    height: 15em;
  }
  .blog-card .meta {
    flex-basis: 40%;
    height: auto;
  }
  .blog-card .description {
    flex-basis: 60%;
  }
  .blog-card .description:before {
    transform: skewX(-3deg);
    content: "";
    background: #fff;
    width: 30px;
    position: absolute;
    left: -10px;
    top: 0;
    bottom: 0;
    z-index: -1;
  }
  .blog-card.alt {
    flex-direction: row-reverse;
  }
  .blog-card.alt .description:before {
    left: inherit;
    right: -10px;
    transform: skew(3deg);
  }
  .blog-card.alt .details {
    padding-left: 25px;
  }
}
@media (max-width: 1280px) {
  .training-jumbotron {
    height: 60rem;
  }
  .blog-info {
    width: 30rem;
  }
}
@media (max-width: 500px) {
  .training-jumbotron {
    height: 100rem;
  }
  .blog-info {
    display: none;
  }
  .more-training-container {
    padding: 1rem;
  }
}
@media (max-width: 1066px) {
  .blog-card {
    max-width: 500px;
    height: 200px;
  }
  .blog-card > p {
    font-size: 0.7em;
  }
  .blog-info {
    width: 30rem;
  }
  .training-jumbotron {
    height: 45em;
  }
  .blog-card .description h1 {
    font-size: 1.2rem;
  }
  .blog-card .description h2 {
    font-size: 0.6rem;
  }
  .blog-card p {
    font-size: 0.7em;
  }
  .blog-card .description .read-more a {
    width: 80px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Courses/Styles.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;AACJ;;AAEE;EACE,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;AACJ;;AAEE;EACE,gBAAA;AACJ;;AAEE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;AACJ;;AAEE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AACJ;;AAEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;AACJ;;AAEE;EACE,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;EACA,kCAAA;EACA,yCAAA;AACJ;;AAEE;EACE,2FAAA;EACA,4BAAA;EACA,4BAAA;AACJ;;AAEE;EACE,8FAAA;EACA,4BAAA;AACJ;;AAEE;EACE,gFAAA;EACA,4BAAA;AACJ;;AAEE;EACE,+EAAA;EACA,4BAAA;AACJ;;AAEE;EACE,0FAAA;EACA,4BAAA;AACJ;;AACE;EACE,mGAAA;EACA,4BAAA;AAEJ;;AACE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6CAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AAEJ;;AAAE;EACE,cAAA;AAGJ;;AADE;EACE,cAAA;AAIJ;;AAFE;EACE,kCAAA;AAKJ;;AAHE;EACE,kCAAA;AAMJ;;AAJE;EACE,kCAAA;AAOJ;;AALE;EACE,kCAAA;AAQJ;;AANE;EACE,kCAAA;AASJ;;AAPE;EACE,kCAAA;AAUJ;;AAPE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;AAUJ;;AARE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,sBAAA;EACA,wBAAA;EACA,0BAAA;AAWJ;;AATE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,sBAAA;EACA,2BAAA;EACA,0BAAA;AAYJ;;AAVE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,sBAAA;EACA,2BAAA;EACA,0BAAA;AAaJ;;AAXE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,sBAAA;EACA,wBAAA;EACA,0BAAA;AAcJ;;AAZE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,sBAAA;EACA,2BAAA;EACA,0BAAA;AAeJ;;AAbE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,sBAAA;EACA,2BAAA;EACA,0BAAA;AAgBJ;;AAbE;;EAEE,YAAA;EACA,UAAA;EACA,gBAAA;AAgBJ;;AAdE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,mCAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;AAiBJ;;AAdE;;EAEE,YAAA;EACA,UAAA;EACA,gBAAA;AAiBJ;;AAfE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,iCAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;AAkBJ;;AAhBE;;EAEE,YAAA;EACA,UAAA;EACA,gBAAA;AAmBJ;;AAjBE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kCAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;AAoBJ;;AAlBE;;EAEE,YAAA;EACA,UAAA;EACA,gBAAA;AAqBJ;;AAnBE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kCAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;AAsBJ;;AApBE;;EAEE,YAAA;EACA,UAAA;EACA,gBAAA;AAuBJ;;AArBE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kCAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;AAwBJ;;AAtBE;;EAEE,YAAA;EACA,UAAA;EACA,gBAAA;AAyBJ;;AAvBE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kCAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;AA0BJ;;AAvBE;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AA0BJ;;AAxBE;;EAEE,gCAAA;AA2BJ;;AAzBE;EACE,cAAA;EACA,SAAA;EACA,iBAAA;AA4BJ;;AA1BE;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;AA6BJ;;AA3BE;EACE,iBAAA;AA8BJ;;AA5BE;EACE,cAAA;EACA,qBAAA;EACA,kBAAA;AA+BJ;;AA7BE;EACE,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,qCAAA;AAgCJ;;AA9BE;EACE,gBAAA;EACA,UAAA;AAiCJ;;AA/BE;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;AAkCJ;;AAhCE;EACE,mBAAA;AAmCJ;;AAjCE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AAoCJ;;AAlCE;EACE,QAAA;AAqCJ;;AAnCE;EACE,QAAA;AAsCJ;;AApCE;EACE,QAAA;AAuCJ;;AArCE;EACE,QAAA;AAwCJ;;AAtCE;EACE,QAAA;AAyCJ;;AAvCE;EACE,QAAA;AA0CJ;;AAvCE;EACE;IACE,mBAAA;IACA,WAAA;IACA,YAAA;EA0CJ;EAxCE;IACE,eAAA;IACA,YAAA;EA0CJ;EAxCE;IACE,eAAA;EA0CJ;EAxCE;IACE,uBAAA;IACA,WAAA;IACA,gBAAA;IACA,WAAA;IACA,kBAAA;IACA,WAAA;IACA,MAAA;IACA,SAAA;IACA,WAAA;EA0CJ;EAxCE;IACE,2BAAA;EA0CJ;EAxCE;IACE,aAAA;IACA,YAAA;IACA,qBAAA;EA0CJ;EAxCE;IACE,kBAAA;EA0CJ;AACF;AAvCE;EACE;IACE,aAAA;EAyCJ;EAvCE;IACE,YAAA;EAyCJ;AACF;AAtCE;EACE;IACE,cAAA;EAwCJ;EArCE;IACE,aAAA;EAuCJ;EApCE;IACE,aAAA;EAsCJ;AACF;AAnCE;EACE;IACE,gBAAA;IACA,aAAA;EAqCJ;EAlCE;IACE,gBAAA;EAoCJ;EAjCE;IACE,YAAA;EAmCJ;EAhCE;IACE,YAAA;EAkCJ;EA/BE;IACE,iBAAA;EAiCJ;EA9BE;IACE,iBAAA;EAgCJ;EA7BE;IACE,gBAAA;EA+BJ;EA5BE;IACE,WAAA;EA8BJ;AACF","sourcesContent":[".courses-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.training-container {\n    display: flex;\n  }\n  \n  .training-jumbotron {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    overflow: hidden;\n    width: 100%;\n    position: relative;\n    background-color: black;\n  }\n  \n  .training-overlay {\n    background-color: black;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    opacity: 0.6;\n    z-index: 2;\n  }\n  \n  video {\n    overflow: hidden;\n  }\n  \n  .training-cards-container {\n    display: flex;\n    flex-direction: column;\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 5;\n  }\n  \n  .more-training {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    flex-wrap: wrap;\n  }\n  \n  .more-training-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    flex-wrap: wrap;\n    padding: 10em 5em;\n  }\n  \n  .blog-info {\n    font-size: 1.5em;\n    line-height: 2.1em;\n    display: flex;\n    position: absolute;\n    z-index: 5;\n    left: 0;\n    width: 50rem;\n    padding: 1rem;\n    bottom: 5%;\n    color: white;\n    font-family: \"Spartan\", sans-serif;\n    animation: fadeIn 1s ease-in-out forwards;\n  }\n  \n  .photo {\n    background-image: url(\"https://ljc-site.s3.us-east-2.amazonaws.com/img/adaptability-Q.png\");\n    background-position: 80% 20%;\n    background-repeat: no-repeat;\n  }\n  \n  .photo-2 {\n    background-image: url(\"https://ljc-site.s3.us-east-2.amazonaws.com/img/change-management.png\");\n    background-repeat: no-repeat;\n  }\n  \n  .photo-3 {\n    background-image: url(\"https://ljc-site.s3.us-east-2.amazonaws.com/img/dei.png\");\n    background-repeat: no-repeat;\n  }\n  \n  .photo-4 {\n    background-image: url(\"https://ljc-site.s3.us-east-2.amazonaws.com/img/hr.png\");\n    background-repeat: no-repeat;\n  }\n  \n  .photo-5 {\n    background-image: url(\"https://ljc-site.s3.us-east-2.amazonaws.com/img/adaptability.jpeg\");\n    background-repeat: no-repeat;\n  }\n  .photo-6 {\n    background-image: url(\"https://ljc-site.s3.us-east-2.amazonaws.com/img/leadership-development.png\");\n    background-repeat: no-repeat;\n  }\n  \n  .blog-card {\n    display: flex;\n    flex-direction: column;\n    margin: 1rem;\n    box-shadow: 0 3px 7px -1px rgba(0, 0, 0, 0.1);\n    margin-bottom: 1.6%;\n    background: #fff;\n    line-height: 1.4;\n    font-family: sans-serif;\n    border-radius: 5px;\n    overflow: hidden;\n    z-index: 0;\n  }\n  .blog-card a {\n    color: inherit;\n  }\n  .blog-card a:hover {\n    color: #5ad67d;\n  }\n  .blog-card:hover .photo {\n    transform: scale(1.3) rotate(3deg);\n  }\n  .blog-card:hover .photo-2 {\n    transform: scale(1.3) rotate(3deg);\n  }\n  .blog-card:hover .photo-3 {\n    transform: scale(1.3) rotate(3deg);\n  }\n  .blog-card:hover .photo-4 {\n    transform: scale(1.3) rotate(3deg);\n  }\n  .blog-card:hover .photo-5 {\n    transform: scale(1.3) rotate(3deg);\n  }\n  .blog-card:hover .photo-6 {\n    transform: scale(1.3) rotate(3deg);\n  }\n  \n  .blog-card .meta {\n    position: relative;\n    z-index: 0;\n    height: 200px;\n  }\n  .blog-card .photo {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-size: cover;\n    background-position: 10%;\n    transition: transform 0.2s;\n  }\n  .blog-card .photo-2 {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-size: cover;\n    background-position: center;\n    transition: transform 0.2s;\n  }\n  .blog-card .photo-3 {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-size: cover;\n    background-position: center;\n    transition: transform 0.2s;\n  }\n  .blog-card .photo-4 {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-size: cover;\n    background-position: 10%;\n    transition: transform 0.2s;\n  }\n  .blog-card .photo-5 {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-size: cover;\n    background-position: center;\n    transition: transform 0.2s;\n  }\n  .blog-card .photo-6 {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-size: cover;\n    background-position: center;\n    transition: transform 0.2s;\n  }\n  \n  .blog-card .details,\n  .blog-card .details ul {\n    margin: auto;\n    padding: 0;\n    list-style: none;\n  }\n  .blog-card .details {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: -100%;\n    margin: auto;\n    transition: left 0.2s;\n    background: rgba(51, 125, 239, 0.6);\n    color: #fff;\n    padding: 10px;\n    width: 100%;\n    font-size: 0.9rem;\n  }\n  \n  .blog-card .details-2,\n  .blog-card .details-2 ul {\n    margin: auto;\n    padding: 0;\n    list-style: none;\n  }\n  .blog-card .details-2 {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: -100%;\n    margin: auto;\n    transition: left 0.2s;\n    background: rgba(57, 8, 121, 0.6);\n    color: #fff;\n    padding: 10px;\n    width: 100%;\n    font-size: 0.9rem;\n  }\n  .blog-card .details-3,\n  .blog-card .details-3 ul {\n    margin: auto;\n    padding: 0;\n    list-style: none;\n  }\n  .blog-card .details-3 {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: -100%;\n    margin: auto;\n    transition: left 0.2s;\n    background: rgba(165, 227, 0, 0.6);\n    color: #fff;\n    padding: 10px;\n    width: 100%;\n    font-size: 0.9rem;\n  }\n  .blog-card .details-4,\n  .blog-card .details-4 ul {\n    margin: auto;\n    padding: 0;\n    list-style: none;\n  }\n  .blog-card .details-4 {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: -100%;\n    margin: auto;\n    transition: left 0.2s;\n    background: rgba(165, 227, 0, 0.6);\n    color: #fff;\n    padding: 10px;\n    width: 100%;\n    font-size: 0.9rem;\n  }\n  .blog-card .details-5,\n  .blog-card .details-5 ul {\n    margin: auto;\n    padding: 0;\n    list-style: none;\n  }\n  .blog-card .details-5 {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: -100%;\n    margin: auto;\n    transition: left 0.2s;\n    background: rgba(165, 227, 0, 0.6);\n    color: #fff;\n    padding: 10px;\n    width: 100%;\n    font-size: 0.9rem;\n  }\n  .blog-card .details-6,\n  .blog-card .details-6 ul {\n    margin: auto;\n    padding: 0;\n    list-style: none;\n  }\n  .blog-card .details-6 {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: -100%;\n    margin: auto;\n    transition: left 0.2s;\n    background: rgba(165, 227, 0, 0.6);\n    color: #fff;\n    padding: 10px;\n    width: 100%;\n    font-size: 0.9rem;\n  }\n  \n  .blog-card .description {\n    padding: 1rem;\n    background: #fff;\n    position: relative;\n    z-index: 1;\n  }\n  .blog-card .description h1,\n  .blog-card .description h2 {\n    font-family: Poppins, sans-serif;\n  }\n  .blog-card .description h1 {\n    line-height: 1;\n    margin: 0;\n    font-size: 1.7rem;\n  }\n  .blog-card .description h2 {\n    font-size: 0.8rem;\n    font-weight: 300;\n    text-transform: uppercase;\n    color: #a2a2a2;\n    margin-top: 5px;\n  }\n  .blog-card .description .read-more {\n    text-align: right;\n  }\n  .blog-card .description .read-more a {\n    color: #5ad67d;\n    display: inline-block;\n    position: relative;\n  }\n  .blog-card .description .read-more a:after {\n    content: \"\";\n    font-family: FontAwesome;\n    margin-left: -10px;\n    opacity: 0;\n    vertical-align: middle;\n    transition: margin 0.3s, opacity 0.3s;\n  }\n  .blog-card .description .read-more a:hover:after {\n    margin-left: 5px;\n    opacity: 1;\n  }\n  .blog-card p {\n    position: relative;\n    margin: 1rem 0 0;\n    font-size: 0.85em;\n  }\n  .blog-card p:first-of-type {\n    margin-top: 1.25rem;\n  }\n  .blog-card p:first-of-type:before {\n    content: \"\";\n    position: absolute;\n    height: 5px;\n    background: #5ad67d;\n    width: 35px;\n    top: -0.75rem;\n    border-radius: 3px;\n  }\n  .blog-card:hover .details {\n    left: 0%;\n  }\n  .blog-card:hover .details-2 {\n    left: 0%;\n  }\n  .blog-card:hover .details-3 {\n    left: 0%;\n  }\n  .blog-card:hover .details-4 {\n    left: 0%;\n  }\n  .blog-card:hover .details-5 {\n    left: 0%;\n  }\n  .blog-card:hover .details-6 {\n    left: 0%;\n  }\n  \n  @media (min-width: 640px) {\n    .blog-card {\n      flex-direction: row;\n      width: 40em;\n      height: 15em;\n    }\n    .blog-card .meta {\n      flex-basis: 40%;\n      height: auto;\n    }\n    .blog-card .description {\n      flex-basis: 60%;\n    }\n    .blog-card .description:before {\n      transform: skewX(-3deg);\n      content: \"\";\n      background: #fff;\n      width: 30px;\n      position: absolute;\n      left: -10px;\n      top: 0;\n      bottom: 0;\n      z-index: -1;\n    }\n    .blog-card.alt {\n      flex-direction: row-reverse;\n    }\n    .blog-card.alt .description:before {\n      left: inherit;\n      right: -10px;\n      transform: skew(3deg);\n    }\n    .blog-card.alt .details {\n      padding-left: 25px;\n    }\n  }\n  \n  @media (max-width: 1280px) {\n    .training-jumbotron {\n      height: 60rem;\n    }\n    .blog-info {\n      width: 30rem;\n    }\n  }\n  \n  @media (max-width: 500px) {\n    .training-jumbotron {\n      height: 100rem;\n    }\n  \n    .blog-info {\n      display: none;\n    }\n  \n    .more-training-container {\n      padding: 1rem;\n    }\n  }\n  \n  @media (max-width: 1066px) {\n    .blog-card {\n      max-width: 500px;\n      height: 200px;\n    }\n  \n    .blog-card > p {\n      font-size: 0.7em;\n    }\n  \n    .blog-info {\n      width: 30rem;\n    }\n  \n    .training-jumbotron {\n      height: 45em;\n    }\n  \n    .blog-card .description h1 {\n      font-size: 1.2rem;\n    }\n  \n    .blog-card .description h2 {\n      font-size: 0.6rem;\n    }\n  \n    .blog-card p {\n      font-size: 0.7em;\n    }\n  \n    .blog-card .description .read-more a {\n      width: 80px;\n    }\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
